import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sg-input',
  templateUrl: './sg-input.component.html',
  styleUrls: ['./sg-input.component.css']
})
export class SgInputComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
